import { queryClient, setTiendaQueryScope } from '../api/queryClient.ts'

type Limpieza = () => void

/** Limpiezas registradas por los módulos (stores de Zustand, preferencias, etc.). */
const limpiezas = new Set<Limpieza>()

/**
 * Registra una función que se ejecuta al cerrar o cambiar de sesión.
 * Pensado para que cada módulo limpie su propio estado sin que base dependa de él.
 * @returns función para anular el registro
 * @example registrarLimpiezaSesion(() => useMiStore.setState(useMiStore.getInitialState(), true))
 */
export const registrarLimpiezaSesion = (limpieza: Limpieza) => {
  limpiezas.add(limpieza)
  return () => {
    limpiezas.delete(limpieza)
  }
}

/**
 * Elimina todo el estado que pertenece a la sesión anterior:
 * caché de React Query (cancelando polling y peticiones en curso) y estados registrados.
 * Se llama al cerrar sesión y antes de aplicar un nuevo login.
 */
export const limpiarDatosSesion = () => {
  void queryClient.cancelQueries()
  queryClient.clear()
  setTiendaQueryScope('')
  limpiezas.forEach((limpieza) => {
    try {
      limpieza()
    } catch (error) {
      console.error('[sesionLimpieza] Error al limpiar estado de sesión', error)
    }
  })
}
